import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPrefillsByUserId,
  createPrefill,
  updatePrefillById,
} from "./prefillThunk";

const initialState = {
  data: [],
  loading: false,
  error: null,
  showPopup: false,
  formData: {
    field_key: "",
    field_value: "",
  },
  selectedPrefillId: null,
};

const prefillSlice = createSlice({
  name: "prefill",
  initialState,
  reducers: {
    handleShowPopup: (state, action) => {
      // state.showPopup = action.payload;
      // state.formData = {};
      state.showPopup = action.payload;
      if (!action.payload) {
        // Reset form and selected ID when popup closes
        state.formData = { field_key: "", field_value: "" };
        state.selectedPrefillId = null;
      }
    },
    handleFormChange: (state, action) => {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    setEditPrefill: (state, action) => {
      const { id, field_key, field_value } = action.payload;
      state.formData = { field_key, field_value };
      state.selectedPrefillId = id;
      state.showPopup = true;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH PREFILLS
      .addCase(fetchPrefillsByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPrefillsByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPrefillsByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE PREFILL
      .addCase(createPrefill.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPrefill.fulfilled, (state) => {
        state.loading = false;
        // formData is already reset in component
        // No update to `data` here because it's re-fetched
      })
      .addCase(createPrefill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updatePrefillById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePrefillById.fulfilled, (state) => {
        state.loading = false;
        state.selectedPrefillId = null;
        state.formData = { field_key: "", field_value: "" };
      })
      .addCase(updatePrefillById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { handleShowPopup, handleFormChange, setEditPrefill } =
  prefillSlice.actions;
export default prefillSlice.reducer;
